const axios = require('axios');
const qs = require('qs');
const Toastify = require('toastify-js');
import 'toastify-js/src/toastify.css';

let forms = document.querySelectorAll('form');
let tels = document.querySelectorAll('a[href^="tel"]');

tels.forEach((tel) =>
  tel.addEventListener('click', function () {
    window.dataLayer.push({'event': 'phone'});
    console.log('click phone');
  })
);

forms.forEach((form) =>
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const url = '/api.php';
    let order = {
      fullname: event.target['name'].value,
      phone: event.target['phone'].value
    };
    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: qs.stringify(order),
      url
    };
    axios(options)
      .then(function (response) {
        Toastify({
          text: 'Спасибо за обращение, мы перезвоним через 5 минут',
          duration: 4000,
          newWindow: true,
          close: false,
          gravity: 'top', // `top` or `bottom`
          position: 'center', // `left`, `center` or `right`
          backgroundColor: 'green',
          stopOnFocus: true // Prevents dismissing of toast on hover
        }).showToast();
        document.querySelector('.popup-bg').style.display = 'none';
        window.dataLayer.push({'event': 'send_form'});
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
        Toastify({
          text: 'Произошла ошибка, попробуйте ещё раз',
          duration: 4000,
          newWindow: true,
          close: false,
          gravity: 'top', // `top` or `bottom`
          position: 'center', // `left`, `center` or `right`
          backgroundColor: 'red',
          stopOnFocus: true // Prevents dismissing of toast on hover
        }).showToast();
      });
  })
);
